
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAccessControl } from '@/hooks/useAccessControl';
import { Button } from '@/components/ui/button';
import { LogIn } from 'lucide-react';

const Index = () => {
  const { isLoggedIn, isAdmin, clientId } = useAccessControl();
  const navigate = useNavigate();
  const [webflowClientId, setWebflowClientId] = useState<string | null>(null);
  const [isInitializing, setIsInitializing] = useState<boolean>(true);

  // Check for webflow client ID on component mount
  useEffect(() => {
    const storedClientId = localStorage.getItem('webflow_versioning_client_id');
    console.log('[Index] Checking for Webflow client ID:', storedClientId);
    setWebflowClientId(storedClientId);
    setIsInitializing(false);
  }, []);

  // Handle redirects based on login type
  useEffect(() => {
    if (isInitializing) return;

    console.log('[Index] Redirect logic - Auth state:', { 
      isLoggedIn, 
      isAdmin, 
      clientId, 
      webflowClientId
    });
    
    if (webflowClientId) {
      // Coming from Webflow integration with client ID - go directly to client page
      console.log('[Index] Webflow entry with client ID:', webflowClientId);
      navigate(`/clients/${webflowClientId}`);
    } else if (isLoggedIn) {
      // Regular app access, already logged in
      console.log('[Index] Regular entry, user is logged in');
      
      if (!isAdmin && clientId) {
        // Regular client user with assigned client
        console.log('[Index] Client user, redirecting to client page:', clientId);
        navigate(`/clients/${clientId}`);
      } else if (isAdmin) {
        // Admin user, go to admin panel
        console.log('[Index] Admin user, redirecting to admin panel');
        navigate('/admin');
      }
    } else {
      // Not logged in and no webflow client id
      console.log('[Index] Regular entry, user not logged in, staying on welcome page');
    }
  }, [isLoggedIn, isAdmin, clientId, webflowClientId, navigate, isInitializing]);
  
  // Handle login button click
  const handleLoginClick = () => {
    navigate('/access');
  };
  
  // Show welcome screen if not logged in or no client ID to display
  return (
    <div className="flex items-center justify-center min-h-screen flex-col gap-6 bg-gray-50">
      <div className="text-center">
        <h1 className="text-3xl font-bold mb-2">Welcome to the Versioning System</h1>
        <p className="text-gray-600 mb-8">Log in to view and manage release versions</p>
      </div>
      
      <Button 
        onClick={handleLoginClick} 
        className="flex items-center gap-2 px-8 py-6 text-lg bg-blue-600 hover:bg-blue-700 text-white rounded-lg shadow-md transition-all"
        size="lg"
      >
        <LogIn className="h-5 w-5" />
        <span>Access System</span>
      </Button>
    </div>
  );
};

export default Index;
